import { LendingModel } from './PriceTier';

export type Price = {
    readonly currency?: string; // e.g. 'AUD';
    readonly netValue?: number;
    readonly usageLimit?: number;
    readonly termLimit?: number;
    readonly lendingModel?: LendingModel;
    readonly basePrice?: number;
    readonly copyBasePrice?: number;
    readonly savedValue?: number;
    readonly savedPercentage?: number;
    readonly copyAmount?: number;
};

export enum SubscriptionPeriodType {
    CURRENT = 'CURRENT',
    NEXT = 'NEXT'
}

export type SubscriptionPeriod = {
    type: SubscriptionPeriodType;
    startDate: string;
    endDate: string;
    lengthInDays: number;
};

/**
 * An article is something that has a price, e.g. a product or a line item.
 */
export type Article = {
    /**
     * The price of the article.
     * For catalogue products this is the main/fallback price.
     * For line items this is the selected price.
     * Can be undefined which indicates the article is not available for being ordered.
     */
    readonly price?: Price;

    /**
     * All available prices of the article, each with a different usage condition.
     */
    readonly availablePrices?: ReadonlyArray<Price>;

    /**
     * The subscription period of the article
     * Only relevant for ePress titles.
     */
    readonly subscriptionPeriod?: SubscriptionPeriod;
};
